import { render } from "./ProjectCoverImage.vue?vue&type=template&id=5737f860&scoped=true"
import script from "./ProjectCoverImage.vue?vue&type=script&lang=js"
export * from "./ProjectCoverImage.vue?vue&type=script&lang=js"

import "./ProjectCoverImage.vue?vue&type=style&index=0&id=5737f860&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5737f860"

export default script